import styled from 'styled-components';

export const DocContainer = styled.div`
  padding: 25px;
  background-color: ${({ theme }) => theme.cardBackground};
  color: ${({ theme }) => theme.textColor};
  border-radius: 8px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.shadowColor};
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.textColor};
  margin-bottom: 20px;
  font-size: 26px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  padding-bottom: 15px;
`;

export const SubTitle = styled.h3`
  color: ${({ theme }) => theme.textColor};
  margin-top: 25px;
  margin-bottom: 15px;
  font-size: 22px;
  font-weight: 600;
`;

export const Paragraph = styled.p`
  line-height: 1.7;
  margin-bottom: 18px;
  color: ${({ theme }) => theme.textColor};
  font-size: 16px;
`;

export const List = styled.ul`
  margin-left: 25px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.textColor};
`;

export const ListItem = styled.li`
  margin-bottom: 10px;
  line-height: 1.6;
  color: ${({ theme }) => theme.textColor};
`;

export const OrderedList = styled.ol`
  margin-left: 25px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.textColor};
`;

export const OrderedListItem = styled.li`
  margin-bottom: 10px;
  line-height: 1.6;
  color: ${({ theme }) => theme.textColor};
`;

export const Code = styled.code`
  background-color: ${({ theme }) => theme.lightGrayColor};
  color: ${({ theme }) => theme.textColor};
  padding: 2px 5px;
  border-radius: 3px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.defaultColor};
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const Note = styled.div`
  background-color: ${({ theme }) => theme.lightGrayColor};
  color: ${({ theme }) => theme.textColor};
  border-left: 4px solid ${({ theme }) => theme.defaultColor};
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
`;

export const Warning = styled.div`
  background-color: ${({ theme }) => theme.lightGrayColor};
  color: ${({ theme }) => theme.textColor};
  border-left: 4px solid ${({ theme }) => theme.warningColor};
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  color: ${({ theme }) => theme.textColor};
`;

export const TableHead = styled.thead`
  background-color: ${({ theme }) => theme.tableHeaderBackground};
  color: ${({ theme }) => theme.tableHeaderText};
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.subRowBackground};
  }
`;

export const TableHeader = styled.th`
  padding: 12px 15px;
  text-align: left;
  border-bottom: 2px solid ${({ theme }) => theme.borderColor};
  color: ${({ theme }) => theme.tableHeaderText};
`;

export const TableCell = styled.td`
  padding: 12px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  color: ${({ theme }) => theme.textColor};
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  border-radius: 4px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.shadowColor};
`;
